import { distinctUntilChanged, map, Observable } from 'rxjs';
import type { GroupingRule } from '@ardoq/api-types';
import { isEqual } from '@ardoq/common-helpers';
import { groupingRules$ } from './groupingRules$';
import { groupingRuleInterface } from 'modelInterface/groupingRules/groupingRuleInterface';

/**
 * The grouping rules as the graph builders take them, with target ids resolved to their
 * global form.
 *
 * Deduped by value because the `map` allocates: `groupingRules$` emits on every dispatch,
 * and `perspectiveEditorRoutines` dispatches `setGroupingRules` on every perspective apply
 * whether or not the rules changed. The views compare this slot by identity, so without
 * this a filter-only apply rebuilt the graph and relayed the diagram out (ARD-33503).
 */
export const graphGroupingRules$: Observable<GroupingRule[]> =
  groupingRules$.pipe(
    map(({ groupingRules }) =>
      groupingRules.map(groupingRuleInterface.toInterfaceType)
    ),
    distinctUntilChanged(isEqual)
  );
